import React, { Component } from "react";

import "./Login.css";
import pic from "../../assets/logo/fasilkom.png";
import Auth from "../../services/Auth/Auth";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.state = {
      username: "",
      password: "",
      isLoading: false,
      isError: false,
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  async handleLogin(e) {
    e.preventDefault();
    this.setState({ isLoading: true, isError: false });
    await Auth.login(this.state.username, this.state.password).then((resp) => {
      if (resp === 200) {
        this.setState({ isLoading: false });
        this.props.navigate("/", { replace: true });
      } else {
        this.setState({ isLoading: false, isError: true });
      }
    });
  }

  render() {
    return (
      <div className="login-page font-sans mt-5 pt-5">
        <div className="flex flex-col items-center mb-4">
          <img src={pic} className="fasilkom-logo" alt="logo-fasilkom" />
          <h6 className="font-bold text-lg">SISIDANG</h6>
        </div>
        <h1 className="mb-4 text-3xl font-semibold">
          Sistem Informasi Penjadwalan Sidang Fasilkom UI
        </h1>
        <h4 className="mb-6">Dilarang memberikan bingkisan kepada pembimbing dan penguji sidang</h4>
        <form
          className="flex flex-col items-center"
          onSubmit={this.handleLogin}
        >
          <input
            type="text"
            required
            placeholder="Username"
            name="username"
            value={this.state.username}
            onChange={this.onChangeUsername}
            className="shadow appearance-none border rounded w-80 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500 mb-4"
          />
          <input
            type="password"
            required
            value={this.state.password}
            onChange={this.onChangePassword}
            placeholder="Password"
            className="shadow appearance-none border rounded w-80 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500 mb-4"
          />
          {this.state.isError && (
            <div
              className="flex w-full px-4 py-2 mb-4 leading-normal text-red-700 bg-red-100 rounded-lg"
              role="alert"
            >
              <p className="flex-auto">Username atau password salah.</p>
              <span className="inset-y-0 right-0 flex items-center">
                <svg
                  className="w-4 h-4 fill-current"
                  role="button"
                  viewBox="0 0 20 20"
                  onClick={() => this.setState({ isError: false })}
                >
                  <path
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  ></path>
                </svg>
              </span>
            </div>
          )}
          <button
            type="submit"
            disabled={this.state.isLoading}
            className="w-80 bg-blue-500 hover:bg-blue-700 text-white text-center font-bold py-2 px-4 rounded disabled:bg-slate-300"
          >
            {this.state.isLoading ? <LoadingSpinner /> : <span>Masuk</span>}
          </button>
        </form>
      </div>
    );
  }
}
